'use client';

import { useState } from 'react';
import { css } from '@bts-web/utils-style-engine';
import { DialogBase } from '../../../DialogBase/DialogBase';
import { useClientTranslation } from '@bts-web/utils-lokalise';
import { TwoFaLayoutWrapper } from '../shared/TwoFaLayoutWrapper';
import { TwoFaSectionTitle } from '../shared/TwoFaSectionTitle';
import { TwoFaSectionDescription } from '../shared/TwoFaSectionDescription';
import { TwoFaSectionButtonsWrapper } from '../shared/TwoFaSectionButtonsWrapper';
import { ButtonBase } from '../../../ButtonBase/ButtonBase';
import { signOutForTwoFaReset } from '../../../../../auth';
import { ModalComponent } from '../../../ModalDrawerContext/ModalDrawerContext';
import { TwoFaContentWrap } from '../shared/TwoFaContentWrap';

const TriggerResetTwoFaModal: ModalComponent = ({ onClose }) => {
  const [loading, setLoading] = useState(false);

  const { t } = useClientTranslation();

  const onLogoutChangeInfo = async () => {
    setLoading(true);

    await signOutForTwoFaReset();

    setLoading(false);
  };

  return (
    <DialogBase
      id="trigger-reset-2fa-modal"
      onClose={onClose}
      size="medium"
      visual="secondary"
      title={t('2fa_reset_title')}
      onMobileFullScreen
      contentProps={{
        disableContentPadding: true,
      }}
      showHeaderBottomDivider
    >
      <TwoFaLayoutWrapper>
        <TwoFaContentWrap>
          <TwoFaSectionTitle title={`${t('2fa_reset_are_you_sure')}`} />
          <TwoFaSectionDescription
            textContent={`${t('2fa_reset_description_body')}`}
          />
        </TwoFaContentWrap>
      </TwoFaLayoutWrapper>
      <TwoFaSectionButtonsWrapper>
        <ButtonBase
          isLoading={loading}
          onClick={onLogoutChangeInfo}
          visual="primary"
          size="large"
          fullWidth
          disabled={loading}
        >
          {t('2fa_reset_accept_button')}
        </ButtonBase>
        <ButtonBase
          disabled={loading}
          isLoading={loading}
          visual="ghost"
          onClick={onClose}
          className={css({
            textDecoration: 'underline',
          })}
        >
          {t('2fa_reset_skip')}
        </ButtonBase>
      </TwoFaSectionButtonsWrapper>
    </DialogBase>
  );
};

export { TriggerResetTwoFaModal };
